import React from 'react';
import PropTypes from 'prop-types';

const Table = ({className, htmlId, children, ...props}) => {
    return(
        <table
            className={className}
            id={htmlId}
            {...props}>
            {children}
        </table>
    );
};

Table.propTypes = {
    //Class which will be applied to table.
    className: PropTypes.string,
    //Child component.
    children: PropTypes.node,
     //HTML id attribute.
    htmlId: PropTypes.string,
};

export default Table;


// WEBPACK FOOTER //
// ./src/components/base/Table/Table.js